import { Badge } from "@ncoder/ui";
import { cn } from "@/lib/utils";
import type { ImpactBucket } from "@/services/salesforce-release";

const BUCKET_COLOR: Record<ImpactBucket, string> = {
  Breaking: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300 border-red-300",
  Deprecated: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300 border-orange-300",
  Review: "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300 border-yellow-300",
  Improvement: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300 border-emerald-300",
  OK: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 border-slate-300",
};

const BUCKET_DOT: Record<ImpactBucket, string> = {
  Breaking: "bg-red-500",
  Deprecated: "bg-orange-500",
  Review: "bg-yellow-500",
  Improvement: "bg-emerald-500",
  OK: "bg-slate-400",
};

export function BucketBadge({ bucket }: { bucket: ImpactBucket }) {
  return (
    <Badge variant="outline" className={cn("font-medium", BUCKET_COLOR[bucket])}>
      {bucket}
    </Badge>
  );
}

export function BucketDot({ bucket, count }: { bucket: ImpactBucket; count: number }) {
  if (!count) return null;
  return (
    <span className="flex items-center gap-1 text-xs text-muted-foreground">
      <span className={cn("h-2 w-2 rounded-full", BUCKET_DOT[bucket])} />
      <span>{count}</span>
    </span>
  );
}

export { BUCKET_COLOR, BUCKET_DOT };
